import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnButton from "@shared/components/SnButton";
import SnTabHeader from "@shared/components/SnTabHeader";
import { Box } from "@mui/material";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  modalRef?: any;
  selectedRowData?: any;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const SN_MAS_SET_REG_014_POP_002 = forwardRef(
  ({ modalRef, selectedRowData }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);

    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);

    const [selectedTapPage, setSelectedTabPage] = useState<string>("1");

    const gridref1 = useRef<any>(null);
    const gridref2 = useRef<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => [
        gridref1.current.getSelectedRows() || [],
        gridref2.current.getSelectedRows() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_SET_REG_014_POP_002", {});
          const mergedData: any = { ...rtn.formData, ...selectedRowData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region onSearch
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_mas_set_reg_014_pop_02_01",
            params: { cd_firm: userInfo.cd_firm, no_if: selectedRowData.no_if },
          };

          setDataSource1([]);
          setDataSource2([]);
          const data: any = await fnGetDataSet(params);
          setDataSource1(data[0]);
          setDataSource2(data[1] || []);

          if (data[0] && data[0].length > 0) {
            const selectNoEst = data[0][0];

            // 1. 그리드 데이터가 바인딩되었음을 기다림
            await new Promise((resolve) => setTimeout(resolve, 50)); // 비동기 반영 대기 (최적화 가능)

            // 2. 첫 번째 행 선택 및 포커스 설정
            gridref1.current.selectAndFocusRow(0);
          }

          gridref1.current.resetUpdate();
          gridref2.current.resetUpdate();
        } catch (error) {}
      };
      fetchdatasource();
    };
    //#endregion

    //#region onGridBtnsClick
    const onGridBtnsClick = async (id: string) => {
      if (id === "btnAdd") {
        if (selectedTapPage === "1") {
          const newRow = {};
          gridref1.current?.addRow(newRow);
        } else if (selectedTapPage === "2") {
          const newRow = {};
          gridref2.current?.addRow(newRow);
        } else {
          return;
        }
      }
      if (id === "btnDelete") {
        if (selectedTapPage === "1") {
          gridref1.current?.deleteSelectedRows();
        } else if (selectedTapPage === "2") {
          gridref2.current?.deleteSelectedRows();
        } else {
          return;
        }
      }
      if (id == "btnSave") {
        let SaveData = {};

        try {
          if (selectedTapPage === "1") {
            const requiredValuesCheck1 = gridref1.current.requiredValuesCheck();
            const changesRow = gridref1.current.getChange();
            if (!requiredValuesCheck1) {
              return;
            }
            SaveData = {
              sys_interface_param: changesRow,
            };
            if (changesRow.modifiedRowcount === 0) {
              await showDialog("alter", "변경된 내용이 없습니다.");
              return;
            }
          } else if (selectedTapPage === "2") {
            const requiredValuesCheck2 = gridref2.current.requiredValuesCheck();
            const changesRow = gridref2.current.getChange();
            if (!requiredValuesCheck2) {
              return;
            }
            SaveData = {
              sys_interface_response: changesRow,
            };
            if (changesRow.modifiedRowcount === 0) {
              await showDialog("alter", "변경된 내용이 없습니다.");
              return;
            }
          } else {
            return;
          }
          // 저장 API 호출
          await fnSave("SN_MAS_SET_REG_014_SAVE_01", SaveData);

          // 성공적으로 저장된 후 초기화
          gridref1.current.resetUpdate();
          gridref2.current.resetUpdate();
        } catch (error: any) {}
      }
    };
    //#endregion

    //#region onTabChanged
    const onTabChanged = (index: string) => {
      setSelectedTabPage(index);
    };
    //#endregion

    //#region onBeforeAddRow
    const onBeforeAddRow = (newRow: RowData): boolean => {
      let maxNoLine = 0;
      const selectedFormData = searchRef.current.getFormdata();
      const selectedData = {
        no_if: selectedFormData.no_if,
      };

      if (selectedTapPage === "1") {
        const allRowData: any[] = [];
        gridref1.current.api.forEachNode((node: any) => {
          allRowData.push(node.data);
        });
        maxNoLine =
          allRowData.length > 0
            ? Math.max(...allRowData.map((row: any) => row.no_line || 0))
            : 0;
      } else if (selectedTapPage === "2") {
        const allRowData: any[] = [];
        gridref2.current.api.forEachNode((node: any) => {
          allRowData.push(node.data);
        });
        maxNoLine =
          allRowData.length > 0
            ? Math.max(...allRowData.map((row: any) => row.no_line || 0))
            : 0;
      }

      try {
        const updatedRow = {
          cd_firm: userInfo.cd_firm,
          no_if: selectedData.no_if,
          no_line: maxNoLine + 1,
          no_seq_sort: maxNoLine + 1,
        };

        Object.assign(newRow, updatedRow);

        return true;
      } catch (error: any) {
        showDialog("error", error.message);
        return false;
      }
    };
    //#endregion

    //#region UI
    return (
      <>
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>

        <div className="h-full flex flex-col">
          <SnTab
            titles={["파라미터", "리턴"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            header={[
              <SnTabHeader
                body={
                  <div className="space-x-1 flex flex-row">
                    <SnButton
                      text={"행추가"}
                      onClick={() => {
                        onGridBtnsClick("btnAdd");
                      }}
                    />
                    <SnButton
                      text={"행삭제"}
                      onClick={() => {
                        onGridBtnsClick("btnDelete");
                      }}
                    />
                    <Box
                      sx={{
                        "& button": {
                          backgroundColor: "rgb(40,154,221)",
                          color: "white",
                          border: "none",
                          boxShadow: 24,
                          p: "6px 12px",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      <SnButton
                        text={"저장"}
                        onClick={() => {
                          onGridBtnsClick("btnSave");
                        }}
                      />
                    </Box>
                  </div>
                }
              ></SnTabHeader>,
              <SnTabHeader
                body={
                  <div className="space-x-1 flex flex-row">
                    <SnButton
                      text={"행추가"}
                      onClick={() => {
                        onGridBtnsClick("btnAdd");
                      }}
                    />
                    <SnButton
                      text={"행삭제"}
                      onClick={() => {
                        onGridBtnsClick("btnDelete");
                      }}
                    />
                    <Box
                      sx={{
                        "& button": {
                          backgroundColor: "rgb(40,154,221)",
                          color: "white",
                          border: "none",
                          boxShadow: 24,
                          p: "6px 12px",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      <SnButton
                        text={"저장"}
                        onClick={() => {
                          onGridBtnsClick("btnSave");
                        }}
                      />
                    </Box>
                  </div>
                }
              ></SnTabHeader>,
            ]}
            body={[
              <SnGrid
                ref={gridref1}
                isEditable={true}
                rowSelection="single"
                columnConfig={columns1}
                rowData={dataSource1}
                onBeforeAddRow={onBeforeAddRow}
              />,

              <SnGrid
                ref={gridref2}
                isEditable={true}
                rowSelection="single"
                columnConfig={columns2}
                rowData={dataSource2}
                onBeforeAddRow={onBeforeAddRow}
              />,
            ]}
          />
        </div>
      </>
    );
  }
  //#endregion
);

export default SN_MAS_SET_REG_014_POP_002;
